import { render, staticRenderFns } from "./content.vue?vue&type=template&id=546e030c&scoped=true&lang=html&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e030c",
  null
  
)

export default component.exports